
export default function SQLs_Data_Types() {
  return (
    <div>
      <h1>SQL Data Types</h1>
      <p>Content for SQL Data Types will go here.</p>
    </div>
  );
}
